import useNavigation from 'core/hooks/navigation/useNavigation'
import { useSettings } from 'core/hooks/settings/useSettings'
import { useEffect } from 'react'
import { hasInAppUrlSearch } from 'utils/AppHelper'

const ApplyMobileView = () => {
  const { search } = useNavigation()
  const {
    set,
    data: { inAppView }
  } = useSettings()

  useEffect(() => {
    if (hasInAppUrlSearch(search) && !inAppView) set('inAppView', true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (inAppView) document.body.classList.add('in-app-view')
  return null
}

export default ApplyMobileView
